import { useEffect } from 'react';
import { useSignalR } from '@/providers/SignalR';
import { useQueryClient } from '@tanstack/react-query';
import { OfferQueryKeys } from './useOfferRequest';
import { LoanOfferQueryKeys } from './useLoanOffer';
import { ApplicationQueryKeys } from '@/features/application/hooks/useApplication';

export const useOfferRequestSignalR = () => {
  const { on, off } = useSignalR();
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleOfferRequestedChanged = () => {
      queryClient.invalidateQueries({
        queryKey: [OfferQueryKeys.offerRequested],
      });
      queryClient.invalidateQueries({
        queryKey: [LoanOfferQueryKeys.loanOfferState],
      });
      queryClient.invalidateQueries({
        queryKey: [ApplicationQueryKeys.applicationState],
      });
    };

    on('partner-final-offer-generated', handleOfferRequestedChanged);
    on('offer-changed', handleOfferRequestedChanged);

    return () => {
      off('partner-final-offer-generated', handleOfferRequestedChanged);
      off('offer-changed', handleOfferRequestedChanged);
    };
  }, []);
};
